import { HttpParams, HttpContext, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { NO_AUTH } from '../no-auth.inteceptor';

@Injectable({
  providedIn: 'root'
})
export class PagarMeService {

  constructor(private http: HttpClient) { }

  public createCardToken(payload: any): Observable<any> {
    const publicKey: string = localStorage.getItem("pagarmePublicKey") || '';
    if (publicKey?.length > 0 && payload?.card?.number?.length > 0) {
      let params = new HttpParams();
      params = params.append("appId", publicKey);
      const context = new HttpContext().set(NO_AUTH, true)

      return this.http.post<any>('https://api.pagar.me/core/v5/tokens', payload, { params, context });
    }
    return of(null);
  }
}
